import { IDashboard } from './../../users.service';
import { Component, OnInit } from '@angular/core';
import { UsersService} from '../../users.service';
import { SelectionModel } from '@angular/cdk/collections';
import { ActivatedRoute, Router } from '@angular/router';
import { ReportDialogComponent } from './report-dialog/report-dialog.component';
import { environment } from 'src/environments/environment';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-reports-list',
  templateUrl: './reports-list.component.html',
  styleUrls: ['./reports-list.component.scss']
})
export class ReportsListComponent implements OnInit {

  userId: string;
  folderId: number;
  reports: IDashboard[] = [];
  displayedColumns: string[] = ['select', 'name', 'screensCount', 'receiverUsers', 'ellipsis'];
  selection = new SelectionModel<IDashboard>(true, []);
  selectedReport: IDashboard;
  loading = false;
  visibleUsersModal: boolean = false;
  userName: string = null;
  url: string;


  constructor(private service: UsersService, private route: ActivatedRoute,
    private snackBar: MatSnackBar, public dialog: MatDialog, private router: Router) { }

  ngOnInit() {
    this.loading = true;
    this.userId = this.service.selectedUserId;
    this.folderId = this.route.snapshot.params.folderId;
    this.url = environment.apiUrl;

    this.getUserName();
    this.service.getUserReports(this.folderId, this.userId).subscribe(res => {
      this.reports = res;
      res.map(rep => {
        if (rep.senderUsers != undefined) {
          this.displayedColumns = ['select', 'name', 'screensCount', 'senderUsers', 'ellipsis'];
        }
      });

    });
    this.loading = false;
  }

  getUserName() {
    this.service.getUsers().subscribe(res => {
      let user = res.find(x => x.id === this.userId);
      this.userName = user.email;
    })
  }

  getReports() {
    this.service.getUserReports(this.folderId, this.userId).subscribe(res => {
      this.reports = res;
    });
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.reports.length;
    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.reports.forEach(row => this.selection.select(row));
  }

  checkboxLabel(row?): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row + 1}`;
  }

  openDialog(rename: boolean): void {
    if (rename) {
      const dialogRef = this.dialog.open(ReportDialogComponent, {
        width: '400px',
        data: { name: this.selectedReport.title, rename: true }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result !== undefined) {
          this.service.renameReport(this.selectedReport.id, result).subscribe(res => {
            this.getReports();
          });
        }
      });
      this.selection.clear();


    } else {
      const dialogRef = this.dialog.open(ReportDialogComponent, {
        width: '400px',
        data: { name: '', rename: false }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result !== undefined) {
          this.service.createReport(this.folderId, result, this.userId).subscribe(res => {
            this.getReports();
          });
        }
      });
      this.selection.clear();

    }
  }

  setSelectedReport(report: IDashboard) {
    this.selectedReport = report;
  }

  redirectToEdit() {
    this.router.navigate(['/main/users/list', this.userId]);
  }

  deleteReports(selected?: boolean) {
    const isConfirm = confirm('Вы действительно хотите удалить выбранный отчет?');
    if (isConfirm) {
      const ids = [];
      if (selected) {
        ids.push(this.selectedReport.id);
      } else {
        for (let i = 0; i < this.selection.selected.length; i++) {
          ids.push(this.selection.selected[i].id);
        }
      }
      this.service.deleteReports(ids).subscribe(res => {
        this.getReports();
        this.selection.clear();
      });
    }
  }


  openWidgets() {
    this.service.setSelectedReportId(this.selectedReport.id);
    this.router.navigate(['/main/users/list', this.userId, 'widgets', this.selectedReport.id]);
  }

  toggleUsersModal(event) {
    this.visibleUsersModal = event;
  }

  share(users) {
    let dashboardIds: number[] = [];
    if (this.selection.selected.length > 0) {
      this.selection.selected.map(it => {
        dashboardIds.push(it.id)
      });
    } else {
      dashboardIds.push(this.selectedReport.id);
    }
    if (dashboardIds.length > 0) {
      this.service.shareDashboards(users.map(u => u.userId), dashboardIds).subscribe(() => {
        this.selection.clear();
        this.getReports();

        this.snackBar.open('Вы успешно поделились выбранными отчетами', '', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'right',
          panelClass: ['snackbar-succes']
        });
      },
        () => {
          this.snackBar.open('Не получилось поделиться выбранными отчетами!', '', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'right',
            panelClass: ['snackbar-error']
          });
        });
    }
    this.toggleUsersModal(false);

  }

}
